import { configureStore } from '@reduxjs/toolkit';
import subtitlesReducer from './features/subtitles/subtitleSlice';

export const store = configureStore({
  reducer: {
    subtitles: subtitlesReducer,
  },
});

export default store;
